<div class="container-fluid p-0">
  <div class="row m-0">
    <div class="col-12 p-0">
      <div class="login-card login-dark">
        <div>
          <div>
            <a class="logo">
              <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="looginpage" />
            </a>
          </div>
          <div class="login-main">
            <form [formGroup]="resetPasswordForm">
              <h4>{{ 'reset-password.title' | translate }}</h4>
              <div class="form-group">
                <label class="col-form-label">{{ 'form.new_password' | translate }}</label>
                <input
                  data-testid="password"
                  class="form-control"
                  type="password"
                  placeholder="*********"
                  formControlName="password"
                  name="password"
                  required
                />
                @if (
                  resetPasswordForm.controls['password'].touched &&
                  resetPasswordForm.controls['password'].errors?.['required']
                ) {
                  <div class="text text-danger mt-1">
                    {{ 'form.validations_error.required_field' | translate }}
                  </div>
                }
                @if (
                  resetPasswordForm.controls['password'].touched &&
                  resetPasswordForm.controls['password'].errors?.['minlength']
                ) {
                  <div class="text text-danger mt-1">
                    {{ 'form.validations_error.password_check_1' | translate }}
                  </div>
                }
                @if (
                  resetPasswordForm.controls['password'].touched &&
                  resetPasswordForm.controls['password'].errors?.['pattern']
                ) {
                  <div class="text text-danger mt-1">
                    {{ 'form.validations_error.password_check_2' | translate }}
                  </div>
                }
              </div>
              <div class="form-group">
                <label class="col-form-label">{{ 'form.confirm_password' | translate }}</label>
                <input
                  data-testid="confirm-password"
                  class="form-control"
                  type="password"
                  placeholder="*********"
                  formControlName="password_confirmation"
                  name="confirmPassword"
                  required
                />
                @if (
                  resetPasswordForm.controls['password_confirmation'].touched &&
                  resetPasswordForm.controls['password_confirmation'].errors?.['required']
                ) {
                  <div class="text text-danger mt-1">
                    {{ 'form.validations_error.required_field' | translate }}
                  </div>
                }
                @if (
                  resetPasswordForm.controls['password_confirmation'].touched &&
                  resetPasswordForm.controls['password_confirmation'].errors?.['minlength']
                ) {
                  <div class="text text-danger mt-1">
                    {{ 'form.validations_error.password_check_1' | translate }}
                  </div>
                }
                @if (
                  resetPasswordForm.controls['password_confirmation'].touched &&
                  resetPasswordForm.controls['password_confirmation'].errors?.['pattern']
                ) {
                  <div class="text text-danger mt-1">
                    {{ 'form.validations_error.password_check_2' | translate }}
                  </div>
                }
              </div>
              <div class="text-end mt-3">
                <button
                  data-testid="reset-password-button"
                  class="btn btn-primary btn-block w-100"
                  (click)="resetPassword()"
                  [disabled]="resetPasswordForm.invalid || !passwordsMatch()"
                >
                  {{ 'buttons.save' | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
